import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FirebaseService } from '../service/firebase.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../modules/usermanagement/server.service';

@Component({
  selector: 'app-user-creation-modal',
  templateUrl: './user-creation-modal.component.html',
  styleUrls: ['./user-creation-modal.component.scss']
})
export class UserCreationModalComponent implements OnInit {
  model: any = { name: null, password: null, role: null, displayName: null };


  constructor(
    public dialogRef: MatDialogRef<UserCreationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private firebaseService: FirebaseService, private snackBar: MatSnackBar, private serverService: ServerService) { }

  ngOnInit() {
  }

  /**
   *Close dialog
   * */

  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * Trigger the creation
   * */

  onCreateUser() {
   // console.log(this.data)
    if (this.data.type != 'sub') {
     /* this.firebaseService.createUser(this.model.email, this.model.role, this.model.displayName, this.model.password).then(() => {
        this.snackBar.open('User created', 'OK', {
          duration: 5000
        })
        this.dialogRef.close();
      }).catch(err => {
        this.snackBar.open(err.message, 'OK', {
          duration: 5000
        })
      })*/

      this.serverService.createUser(this.model.email, this.model.password, this.model.displayName, this.model.role).then(d => {
        this.snackBar.open('User created', 'OK', {
          duration: 5000
        })
        this.dialogRef.close();
      }).catch(err => {
        this.snackBar.open(err.message, 'OK', {
          duration: 5000
        })
      })

    }


    else
      this.serverService.createSubUser(this.model.email, this.model.password, this.model.displayName).then(() => {
        this.snackBar.open('Utilisateur en cours de création, cela peut prendre quelques minutes. ⏱️', 'OK', {
          duration: 5000
        })
        this.dialogRef.close();
      }).catch(err => {
        this.snackBar.open(err.message, 'OK', {
          duration: 5000
        })
      })
  }

}
